import React from 'react';
import { useMediaLoader } from '../../hooks/useMediaLoader';
import AnimatronicCardBase from '../animatronics/cards/AnimatronicCardBase';

interface RankingCardProps {
  animatronic: {
    id: string;
    name: string;
    type: string;
    park: string;
    attraction: string;
    country: string;
    media: any;
  };
  onSelect: () => void;
  isLoading?: boolean;
}

const RankingCard: React.FC<RankingCardProps> = ({ 
  animatronic, 
  onSelect,
  isLoading = false 
}) => {
  const { validMedia, isLoading: isMediaLoading } = useMediaLoader(animatronic?.media || []);

  const handleClick = (e: React.MouseEvent) => {
    if (isLoading) return;
    
    if (!(e.target as HTMLElement).closest('.swiper-button-next, .swiper-button-prev')) {
      onSelect();
    }
  };

  if (!animatronic) return null;

  return (
    <div 
      className={`transform transition-all duration-300 hover:scale-[1.02] cursor-pointer relative group ${
        isLoading ? 'opacity-50 pointer-events-none' : ''
      }`}
      onClick={handleClick}
    >
      <AnimatronicCardBase
        name={animatronic.name}
        type={animatronic.type}
        media={validMedia}
        isLoading={isMediaLoading}
        onClick={(e) => e.stopPropagation()}
        allowNavigation={true}
        disableCardClick={true}
        compact={true}
      >
        <div className="text-center">
          <h3 className="text-sm sm:text-base font-semibold mb-1 text-content-primary group-hover:text-brand transition-colors line-clamp-2 sm:line-clamp-1">
            {animatronic.name}
          </h3>
          <p className="text-xs sm:text-sm text-content-secondary line-clamp-1">
            {animatronic.attraction}
          </p>
        </div>
      </AnimatronicCardBase>
    </div>
  );
};

export default RankingCard;
